app.factory("SubscriptionFactory", [
  "$http",
  "config",
  "$q",
  function ($http, config, $q) {
    function createSubscription(customerId) {
      let q = $q.defer();
      $http({
        method: "POST",
        url: `${config.fstreamAPI}stripe/subscription`,
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
        },
        data: {
          customerID: customerId,
        },
      }).then(
        function success(response) {
          q.resolve(response.data);
        },
        function error(response) {
          q.reject(response);
        }
      );
      return q.promise;
    }

    function getCustomerSubscription() {
      let q = $q.defer();
      $http({
        method: "GET",
        url: `${config.fstreamAPI}microsite/subscription/ticket`,
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
        },
      }).then(
        function success(response) {
          q.resolve(response.data);
        },
        function error() {
          q.reject(null);
        }
      );
      return q.promise;
    }

    function cancelSubscription(shouldCancelAfterPeriod) {
      let q = $q.defer();
      $http({
        method: "PATCH",
        url: `${config.fstreamAPI}stripe/subscription`,
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
        },
        data: {
          cancelAtPeriodEnd: shouldCancelAfterPeriod,
        },
      }).then(
        function success() {
          q.resolve();
        },
        function error() {
          q.reject(null);
        }
      );
      return q.promise;
    }

    function getSubscriptionDetails(micrositeId) {
      let q = $q.defer();
      $http({
        method: "GET",
        url: `${config.fstreamAPI}microsite/subscription/${micrositeId}`,
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
        },
      }).then(
        function success(response) {
          q.resolve(response.data);
        },
        function error() {
          q.reject(null);
        }
      );
      return q.promise;
    }

    return {
      createSubscription: createSubscription,
      getCustomerSubscription: getCustomerSubscription,
      cancelSubscription: cancelSubscription,
      getSubscriptionDetails: getSubscriptionDetails,
    };
  },
]);
